import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import axios from 'axios';
import { global } from '../../global';

const {
  img: {
    logos: {
      AviancaLogo,
      LatamLogo,
      VivaLogo,
    }
  }

} = global;


function useFlightsSearch() {
  const location = useLocation().state;
  const [loading, setLoading] = useState(false);
  const [queryError, setQueryError] = useState(false);
  const [flightsList, setFlightsList] = useState([]);
  const numberSearchs = 50
  const classFlight = false
  const [isRoundTrip, setIsRoundTrip] = useState(location.roundTrip);
  const [allPassengersSelected, setAllPassengersSelected] = useState(location?.passengersSelecteds);
  const [numberOfAdultPassengers, setNumberOfAdultPassengers] = useState(allPassengersSelected?.adult);
  const [numberOfBoyPassengers, setNumberOfBoyPassengers] = useState(allPassengersSelected?.boy);
  const [numberOfBabyPassengers, setNumberOfBabyPassengers] = useState(allPassengersSelected?.baby);
  const errorGetFlight = 'Request failed with status code 500';

  const [nameOrigin, setNameOrigin] = useState(location?.buttonOriginFlight);
  const [nameDestiny, setNameDestiny] = useState(location?.buttonDestinityFlight);
  
  const [dateGoingSelected, setDateGoingSelected ]= useState('')
  const [dateGoingSelectedApi, setDateGoingSelectedApi ]= useState(location?.dateGoingSelectedApi);

  const [dateReturnSelected, setDateReturnSelected]= useState('')
  const [dateReturnSelectedApi, setDateReturnSelectedApi ]= useState(location?.dateReturnSelectedApi);
  
  const codeIataDestiny = location?.codeiataDestinity;
  const codeIataOrigin = location?.codeIataOrigin;

  const airlinesList = [
    {
      id: 1,
      img: VivaLogo,
      name: 'viva air',
      priceDirect: 1050,
      priceOneScale: 950,
      priceMoreScale: null,
    },
    {
      id: 2,
      img: LatamLogo,
      name: 'latam airlines',
      priceDirect: 1100,
      priceOneScale: 1080,
      priceMoreScale: null,
    },
    {
      id: 3,
      img: AviancaLogo,
      name: 'avianca',
      priceDirect: 1120,
      priceOneScale: 1100,
      priceMoreScale: 1050,
    },
  ]
  
  console.log("salida ===> ", codeIataDestiny)
  console.log("llegada ===> ",codeIataOrigin )
  console.log("he aqui el problema? ........................................")

  const dataToSend = {
    "searchs": numberSearchs,
    "class": classFlight,
    "qtyPassengers": numberOfAdultPassengers + numberOfBoyPassengers,
    "adult": numberOfAdultPassengers,
    "child": numberOfBoyPassengers,
    "baby": numberOfBabyPassengers,
    "itinerary":
      [
        {
          "departureCity": `${codeIataDestiny }`,
          "arrivalCity": `${codeIataOrigin}`,
          "hour": `${dateGoingSelectedApi}`
        },
      ]
  }

  if (isRoundTrip) {
    dataToSend.itinerary.push(
      {
        "departureCity": `${codeIataOrigin }`,
        "arrivalCity": `${codeIataDestiny}`,
        "hour": `${dateReturnSelectedApi}`
      }
    )
  }


  async function getFlights() {
    setLoading(true)
    setQueryError(false)
    try {
      const url = process.env.REACT_APP_URL_API_FLY;
      const result = await axios.post(url, dataToSend);
      setFlightsList(result?.data?.data);
    } catch (error) {

      console.log({ error })
      if (error?.message === errorGetFlight) {
        console.log("no hay resultados")
        setQueryError(true)
      }
      console.log("Error in getFlights: ", error);
    }
    finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getFlights();
  }, []);

  return {
    loading,
    isRoundTrip,setIsRoundTrip,
    queryError,
    flightsList,
    airlinesList,
    nameOrigin, setNameOrigin,
    nameDestiny, setNameDestiny,
    getFlights,
    allPassengersSelected,
    setAllPassengersSelected,

    setDateGoingSelected,
    dateGoingSelected,
    setDateGoingSelectedApi,
    setDateReturnSelected,
    setDateReturnSelectedApi,
    dateReturnSelected


  }
}

export default useFlightsSearch;